module.exports = __webpack_public_path__ + "media/unipod/wall_tiling-a3b37a19.jpg";